import { ContainerModule, interfaces } from "inversify";
import {
  InteractiveComponentFactory,
  InteractiveComponentFactorySymbol
} from "./api/interactive-component-factory";
import * as Api from "@/app/interaction/api";
import { PlayerModuleSymbol } from '@/app/api';
import { interactionStoreContainerModule } from './store/di'
import { interactionServiceModule } from './service/di'
import { InteractionPlayerModule } from './interaction-player-module'

const interactiveComponentPluginModule = new ContainerModule(bind => {
  bind<InteractiveComponentFactory<unknown, unknown>>(
    InteractiveComponentFactorySymbol
  ).toFactory<Vue>((context: interfaces.Context) => {
    return (
      componentType: string,
      propsData: unknown
    ) => {
      if (
        context.container.isBoundNamed(
          Api.InteractiveComponentPluginSymbol,
          componentType
        )
      ) {
        const ComponentConstructor = context.container.getNamed<Api.InteractiveComponentPlugin>(
          Api.InteractiveComponentPluginSymbol, componentType);

        return new ComponentConstructor({ propsData });
      } else {
        throw new Error(
          `Coding error: Interactive component not found for type '${componentType}'.`
        );
      }
    };
  });
});


const interactionModule = new ContainerModule((bind) => {
  bind(PlayerModuleSymbol).to(InteractionPlayerModule)  
});

export const interactionModules = [
  interactionModule,
  interactiveComponentPluginModule,
  interactionStoreContainerModule,
  interactionServiceModule
]

